'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload from "./presto.types$-Two-Factor-Auth-Seed-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthSeedPayload$() {
}
export { $c_Lpresto_types$TwoFactorAuthSeedPayload$ as $c_Lpresto_types$TwoFactorAuthSeedPayload$ };
$p = $c_Lpresto_types$TwoFactorAuthSeedPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthSeedPayload$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthSeedPayload$() {
}
export { $h_Lpresto_types$TwoFactorAuthSeedPayload$ as $h_Lpresto_types$TwoFactorAuthSeedPayload$ };
$h_Lpresto_types$TwoFactorAuthSeedPayload$.prototype = $p;
$p.l = (function() {
  return "TwoFactorAuthSeedPayload";
});
$p.cHE = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload.$c_Lpresto_types$TwoFactorAuthSeedPayload(x$0.j(0));
});
var $d_Lpresto_types$TwoFactorAuthSeedPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthSeedPayload$, "presto.types$TwoFactorAuthSeedPayload$", ({
  a2y: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TwoFactorAuthSeedPayload$ as $d_Lpresto_types$TwoFactorAuthSeedPayload$ };
var $n_Lpresto_types$TwoFactorAuthSeedPayload$;
function $m_Lpresto_types$TwoFactorAuthSeedPayload$() {
  if ((!$n_Lpresto_types$TwoFactorAuthSeedPayload$)) {
    $n_Lpresto_types$TwoFactorAuthSeedPayload$ = new $c_Lpresto_types$TwoFactorAuthSeedPayload$();
  }
  return $n_Lpresto_types$TwoFactorAuthSeedPayload$;
}
export { $m_Lpresto_types$TwoFactorAuthSeedPayload$ as $m_Lpresto_types$TwoFactorAuthSeedPayload$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Seed-Payload$.js.map
